import '/assets/styles/sections/web-menu-header.scss';
import classNames from 'classnames';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';

const WebMenuHeader = ({ title, backLink, className }) => {
	return (
		<section className={classNames('section', 'web-menu-header', className)}>
			<div className="wrapper header-wrap">
				{backLink !== false && (
					<>
						{backLink ? (
							<Link className="header-backbtn" {...backLink}>
								<Icon name="angle-left" />
							</Link>
						) : (
							<span className="header-backbtn disabled">
								<Icon name="angle-left" />
							</span>
						)}
					</>
				)}

				<Img src={image_logo} className="header-logo" />
				{title ? (
					<h1 className="header-title">{title}</h1>
				) : (
					<Placeholder className="header-title" />
				)}
			</div>
		</section>
	);
};

export default WebMenuHeader;
